import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AUTH_TOKEN_STORAGE_KEY } from '../../shared/models/auth.model';
import { environment } from '../../../environments/environment';

interface DecodedJwtPayload {
  exp?: number;
  roles?: string[];
  [claim: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(): boolean | UrlTree {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    if (!token || this.isExpired(token)) {
      console.warn('[AuthGuard] No valid token found — redirecting to /auth/login.');
      if (!environment.production) {
        console.info('[AuthGuard] No token found — guard redirecting to /auth/login.');
      }
      return this.router.createUrlTree(['/auth/login']);
    }

    return true;
  }

  private isExpired(token: string): boolean {
    const claims = this.decodeJwt(token);
    if (!claims?.exp) {
      return false;
    }
    return claims.exp * 1000 <= Date.now();
  }

  private decodeJwt(token: string): DecodedJwtPayload | null {
    try {
      const payloadSegment = token.split('.')[1];
      if (!payloadSegment) {
        return null;
      }
      const json = atob(payloadSegment.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(json) as DecodedJwtPayload;
    } catch {
      return null;
    }
  }
}
